export default "__VITE_ASSET__1a7bd37e__"